import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import userbase from 'userbase-js'
import { AccountFields } from './edit-profile/AccountFields'
import { SafetyFields } from './edit-profile/SafetyFields'
import { VaccineFields } from './edit-profile/VaccineFields'
import { Button } from '../components/buttons'

export const EditProfile = ({ user }) => {
  const history = useHistory()

  const [editProfileForm, setEditProfileForm] = useState({
    username: '',
    currentPassword: '',
    newPassword: '',
    email: '',
    profile: {
      ...user.profile,
    },
  })

  const cleanObject = (object) => {
    for (const property in object) {
      if (typeof object[property] === 'object') {
        cleanObject(object[property])

        if (Object.keys(object[property]).length === 0) {
          delete object[property]
        }
      } else if (object[property] === '') {
        delete object[property]
      }
    }
    return object
  }

  const handleEditProfileInputChange = (event) => {
    if (
      event.target.name === 'firstName' ||
      event.target.name === 'lastName' ||
      event.target.name === 'phone'
    ) {
      setEditProfileForm({
        ...editProfileForm,
        profile: {
          ...editProfileForm.profile,
          [event.target.name]: event.target.value,
        },
      })
    } else {
      setEditProfileForm({
        ...editProfileForm,
        [event.target.name]: event.target.value,
      })
    }
  }

  const handleEditProfileSubmit = (event) => {
    event.preventDefault()

    console.log(cleanObject(editProfileForm))

    userbase
      .updateUser(cleanObject(editProfileForm))
      .then(() => {
        history.push({ pathname: '/' })
      })
      .catch((err) => alert(err))
  }

  return (
    <div className="container-md py-64">
      <h2 className="text-30 text-purple-dark mb-40">Edit Your Profile</h2>
      <form onSubmit={handleEditProfileSubmit} id="edit-profile">
        <AccountFields
          user={user}
          handleChange={handleEditProfileInputChange}
        />
        <SafetyFields user={user} handleChange={handleEditProfileInputChange} />
        <VaccineFields
          user={user}
          handleChange={handleEditProfileInputChange}
        />
      </form>
      <Button
        className="bg-purple-light border-2 border-purple-light text-white rounded-10 mb-20 sm:mb-0 sm:mr-20"
        type="submit"
        value="Submit"
        form="edit-profile"
      >
        Save changes
      </Button>
    </div>
  )
}
